<template>
    <v-col cols="12" sm="auto" md="auto" style="cursor:pointer;">
        <v-card class="kicker"
                v-scroll-to="'#collegecard'"
                elevation="4"
                color="red darken-2"
                dark>
            <div style="float:right;" class="ma-0 mt-2 mr-1">
                <span v-if="HasCollegeCard" class="fa-stack fa-lg icon-success">
                    <i class="fa fa-circle fa-stack-2x"></i>
                    <i class="fa fa-check fa-stack-1x"></i>
                </span>
                <span v-else class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-info"></i>
                    <i class="fas fa-info fa-stack-1x"></i>
                </span>
            </div>
            <v-card-title>Your Student Card</v-card-title>
            <v-card-text>
                <p v-if="HasCollegeCard" class="ma-0">Your card is active</p>
                <p v-else class="ma-0">View the status of your card</p>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    import collegeCardsMixin from '@/views/components/mixins/collegeCards.js'

    export default {
        props: ['collegeCard'],
        mixins: [
            collegeCardsMixin,
        ],
    }
</script>
